export default {
  UNRESOLVED: { name: 'Nierozwiązane', id: 'unmarked' },
  EASY: { name: 'Łatwe', id: 'easy' },
  HARD: { name: 'Trudne', id: 'hard' },
  EXPLAIN: { name: 'Do\xa0wyjaśnienia', id: 'explain' },
};
